module.exports = "#exp-tab-name{\r\n    margin-top: 36px;\r\n}\r\n.moreOptnsPack{\r\nmargin-left: 36%;\r\nfont-size: 12px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-package-options/expert-package-options.component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-package-options/expert-package-options.component.css
// module chunks = main